import { DisputeChargebackStatus } from "@/models/enum/dispute-chargeback-status";

export class DisputeChargebackLogFilters {
  dateFrom?: string;
  dateTo?: string;
  accountNames?: string[];
  statuses?: DisputeChargebackStatus[];
  chargebackIds?: string[];
}

